export { default } from './SidebarDivider.js';
